import React from "react"
import { useTranslation } from "react-i18next"

import { AddingEventCard } from "~/components/ContentEditable/components/AddingEventCard/AddingEventCard"
import { Goto } from "~/components/ContentEditable/components/Goto/Goto"
import { ContentEditable } from "~/components/ContentEditable/ContentEditable"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const Content: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.Wrapper}>
      <div className={styles.ColLeft}>
        <ContentEditable>
          <Heading like="h1">
            <Raw html={t("stockholders-meeting.Heading")} />
          </Heading>

          <AddingEventCard className="d-sm-none" inStockholdersMeeting />

          <Heading like="h3">
            <Raw html={t("stockholders-meeting.Position")} />
          </Heading>

          <p dangerouslySetInnerHTML={{ __html: t("stockholders-meeting.Text.01") }} />

          <Heading like="h2">
            <Raw html={t("stockholders-meeting.Title")} />
          </Heading>

          <Heading like="h4">
            <Raw html={t("stockholders-meeting.SubTitle.01")} />
          </Heading>

          <p dangerouslySetInnerHTML={{ __html: t("stockholders-meeting.Text.02") }} />

          <p dangerouslySetInnerHTML={{ __html: t("stockholders-meeting.Text.03") }} />

          <p dangerouslySetInnerHTML={{ __html: t("stockholders-meeting.Text.04") }} />

          <p dangerouslySetInnerHTML={{ __html: t("stockholders-meeting.Text.05") }} />

          <Heading like="h4">
            <Raw html={t("stockholders-meeting.SubTitle.02")} />
          </Heading>

          <p dangerouslySetInnerHTML={{ __html: t("stockholders-meeting.Text.06") }} />

          <p dangerouslySetInnerHTML={{ __html: t("stockholders-meeting.Text.07") }} />

          <Goto
            link="/investors-and-shareholders/stockholders-meeting/materials"
            linkName={t("stockholders-meeting.Archive.Title")}
            title={t("stockholders-meeting.Archive.Link")}
          />

          <Heading like="h4">
            <Raw html={t("stockholders-meeting.SubTitle.03")} />
          </Heading>

          <p dangerouslySetInnerHTML={{ __html: t("stockholders-meeting.Text.08") }} />

          <p dangerouslySetInnerHTML={{ __html: t("stockholders-meeting.Text.09") }} />

          <p dangerouslySetInnerHTML={{ __html: t("stockholders-meeting.Text.10") }} />
        </ContentEditable>
      </div>

      <div className={styles.ColRight}>
        <AddingEventCard inStockholdersMeeting />
      </div>
    </div>
  )
}
